export const getters = {
  allIdpsData: (state) => {
    return state.allIdpsData
  }
}
